import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { AuthenticationService } from "app/auth/service";

@Component({
  selector: "app-modal-deletar-bottom",
  templateUrl: "./modal-deletar-bottom.component.html",
  styleUrls: ["./modal-deletar-bottom.component.scss"],
})
export class ModalDeletarBottomComponent implements OnInit {
  @Input() cancelar;
  mostrar: boolean = false;
  @Output() deleteRequest = new EventEmitter<any>();
  
  constructor(public auth: AuthenticationService) {}

  ngOnInit(): void {
  
  }

  toggle() {
    this.mostrar = !this.mostrar;
  }
  mostrarModal(){
    this.toggle();
  }
  
}
